import React from 'react';
import {Box, ToggleButton, ToggleButtonGroup, Typography} from '@mui/material';

import {TAG_COLORS} from '../../helpers/MemberTagHelper';
import {SENTIMENT} from "../../helpers/SessionHelper";

const styles = {
    box: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
        },
        indicator: {
            borderRadius: '50%',
            display: 'inline-block',
            height: '1rem',
            marginRight: '0.5rem',
            width: '1rem',
        }
    },
    toggleButton: {
        '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        textTransform: 'none',
    },
    typography: {
        label: {
            fontSize: '0.875rem',
            fontWeight: 500,
        }
    }
};

export default function TagTypeToggle({value, onChange}) {
    const handleChange = (event, newValue) => {
        if (newValue !== null) {
            onChange(newValue);
        }
    };

    return (
        <Box sx={styles.box.container}>
            <Typography sx={styles.typography.label}>Tag Type</Typography>
            <ToggleButtonGroup
                value={value}
                exclusive
                onChange={handleChange}
                aria-label="tag type"
                fullWidth>
                <ToggleButton value={SENTIMENT.POSITIVE} sx={styles.toggleButton}>
                    <Box sx={{...styles.box.indicator, backgroundColor: TAG_COLORS.POSITIVE}} />
                    Positive
                </ToggleButton>
                <ToggleButton value={SENTIMENT.NEGATIVE} sx={styles.toggleButton}>
                    <Box sx={{...styles.box.indicator, backgroundColor: TAG_COLORS.NEGATIVE}} />
                    Needs Attention
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
